import apiService from './apiService';

export interface DepartmentPayload {
  name: string;
  code: string;
  description: string;
}

export const getDepartments = async () => {
  try {
    const response = await apiService.get(`departments`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
};

export const createDepartment = async (payload: DepartmentPayload) => {
  try {
    const response = await apiService.post('departments', payload);
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Error creating department:', error);
    throw error;
  }
};

export const updateDepartment = async (id: number, payload: DepartmentPayload) => {
  try {
    const response = await apiService.put(`departments/${id}`, payload);
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Error updating department:', error);
    throw error;
  }
};

export const deleteDepartment = async (id: number) => {
  try {
    const response = await apiService.delete(`departments/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting department:', error);
    throw error;
  }
};
